import apiClient from '../apiClient';

export const getAdminPages = async () => {
  try {
    const response = await apiClient.get('/admin/pages');
    return response.data;
  } catch (error) {
    console.error('Error fetching pages:', error);
    throw error;
  }
};

export const createPage = async (payload) => {
  try {
    const response = await apiClient.post('/admin/pages', payload);
    return response.data;
  } catch (error) {
    console.error('Error creating page:', error);
    throw error;
  }
};

export const updatePage = async (id, payload) => {
  try {
    const response = await apiClient.put(`/admin/pages/${id}`, payload);
    return response.data;
  } catch (error) {
    console.error('Error updating page:', error);
    throw error;
  }
};

export const deletePage = async (id) => {
  try {
    await apiClient.delete(`/admin/pages/${id}`);
  } catch (error) {
    console.error('Error deleting page:', error);
    throw error;
  }
};
